

export const assessmentBuilderHeading = "Build engaging classroom activities";

export const assessmentBuilderSubtitle =
"Design activities that drive concept clarity and student participation";

export {
  familiarTopics,
  familiarTopicsHeading,
} from "../shared/familiarTopics";

export const targetFormatOptions = [
{ id: "teaching-guide", label: "TEACHING GUIDE" },
{ id: "exit-ticket", label: "EXIT TICKET" },
{ id: "check-in", label: "CHECK-IN" }];


export const generateStructuredQuestionsLabel = "Generate Structured Questions";

export const generateStructuredQuestionsHint =
"Creates a progression from basic understanding to deeper thinking";

export const defaultQuickAssessmentConfig = {
  selectedTopicId: "",
  selectedTopicLabel: "",
  targetFormat: "teaching-guide"
};

export const generatingAssessmentMessage = "Generating structured assessment…";